import { MultiSectionDigitalClock } from "@mui/x-date-pickers";
import moment from "moment";
import { formatTime, parseTimeToDate } from "../../utils/helpers";
import Dropdown from "../dropdown/dropdown";
import { TextInput } from "./textInput";

export const TimeInput = ({
  placeholder = "",
  errors = "",
  title = "",
  time,
  setDate = () => {},
  onBlur,
  className = "",
  name,
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title: string;
  time?: Date | null;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (time: Date | null) => void;
  className?: string;
}) => {
  return (
    <Dropdown
      customMenuItems={
        <div className={className}>
          <MultiSectionDigitalClock
            value={time ? moment(parseTimeToDate(formatTime(time))) : null}
            onChange={(newTime) => {
              setDate(newTime);
            }}
            timeSteps={{ hours: 1, minutes: 1 }}
            sx={{
              "& .MuiMultiSectionDigitalClock-root.css-11cy34b-MuiMultiSectionDigitalClock-root":
                {
                  borderBottom: "none !important",
                  width: "70px",
                },
              "& .css-ux17pc-MuiButtonBase-root-MuiMenuItem-root-MuiMultiSectionDigitalClockSection-item.Mui-selected":
                {
                  backgroundColor: "#04000A",
                  color: "white",
                },
              "& .css-ux17pc-MuiButtonBase-root-MuiMenuItem-root-MuiMultiSectionDigitalClockSection-item":
                {
                  borderRadius: "100%",
                  minWidth: "36px",
                  minHeight: "36px",
                  maxWidth: "36px",
                  maxHeight: "36px",
                  fontSize: "14px !important",
                },
              "& .css-8ge7h6-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type)":
                {
                  borderLeft: "none",
                },
            }}
          />
        </div>
      }
      menuClassName="rounded-xl bg-white !shadow-sm border !max-w-fit !p-3 !pb-0"
      closeOnClick={false}
      className={`w-full`}
    >
      <TextInput
        type="text"
        name={name}
        value={formatTime(time)}
        placeholder={placeholder}
        onChange={() => {}}
        onBlur={onBlur}
        hasTitle
        title={title}
        errors={errors}
        containerClassName=""
        readOnly
      />
    </Dropdown>
  );
};
